const NAMESPACE = "eSignatureConstants";

const KEYS = {
    cancelExplanationTypeOtherLabel: "cancelExplanationTypeOtherLabel",
    cancelExplanationTypeResendingLabel: "cancelExplanationTypeResendingLabel",
    cancelExplanationTypeCorrectingRecipientLabel: "cancelExplanationTypeCorrectingRecipientLabel",
    cancelExplanationTypeUpdatingContentsLabel: "cancelExplanationTypeUpdatingContentsLabel",
    cancelExplanationTypeCpAdminLabel: "cancelExplanationTypeCpAdminLabel",
    signatureTypeESign: "signatureTypeESign",
    signatureTypeWetSign: "signatureTypeWetSign"
};

const MESSAGES = {
    [KEYS.cancelExplanationTypeOtherLabel]: {
        value: "Other",
        comment: "Label for an otherwise un-enumerated cancel explanation"
    },
    [KEYS.cancelExplanationTypeResendingLabel]: {
        value: "Recipient did not receive the notification email",
        comment: "Cancel explanation indicating that the intended recipient did not receive the notification email"
    },
    [KEYS.cancelExplanationTypeCorrectingRecipientLabel]: {
        value: "Need to correct recipient contact info",
        comment: "Cancel explanation indicating that the user wants to correct a recipient's contact info"
    },
    [KEYS.cancelExplanationTypeUpdatingContentsLabel]: {
        value: "Need to update envelope document contents",
        comment:
            "Cancel explanation indicating that the user needs to update the contents of the documents sent for signature"
    },
    [KEYS.cancelExplanationTypeCpAdminLabel]: {
        value: "CPAdmin",
        comment: "Cancel explanation reserved for cancellation via CPAdmin"
    },
    [KEYS.signatureTypeESign]: {
        value: "eSign",
        comment: "Display text indicating that an envelope will be eSigned (electronically signed)"
    },
    [KEYS.signatureTypeWetSign]: {
        value: "Wet Sign",
        comment:
            "Display text indicating that an envelope has documents that need to be wet signed (signed, scanned, and uploaded)"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
